export const ERROR = 'alert/ALERT_ERROR';
export const CLEAR = 'alert/ALERT_CLEAR';

const initialState = {};

export default function alert(state = initialState, { payload, type }) {
  switch (type) {
    case ERROR:
      return {
        ...state,
        message: { text: payload.text, status: payload.status }
      };
    case CLEAR:
      return {};
    default:
      return state;
  }
}

export const showError = ({ text, status }) => ({
  type: ERROR,
  payload: {
    status,
    text
  }
});
export const clearMessage = () => ({
  type: CLEAR
});



// WEBPACK FOOTER //
// ./src/core/alert/index.js